import { deprecated } from "@gr-common/async/logger";

otto.debug.assignNamespace({
  sendLog: deprecated(
    (namespace, data) => otto.apm.sendCustomError(namespace, data),
    "debug",
    "sendLog",
    "sendLog is deprecated, please use apm/captureError instead.",
  ),
});
